import { store } from '../../../../resources/frontend/js/store/index';
import convertToPx from './convert-to-px';
import convertToVw from './convert-to-vw';

/**
 * Convert values to px or vw depending on device type
 * @param {number} value
 * @param {boolean} mobileToPX
 * @param {boolean} unitLess
 * @return {string | number}
 */
export default (value, mobileToPX = false, unitLess = false) => {
    const deviceType = store.state.page.deviceType;

    if (deviceType === 'desktop') {
        if (unitLess) {
            return value;
        } else {
            return `${value}px`;
        }
    }

    if (deviceType === 'mobile' && !mobileToPX) {
        return convertToVw(value);
    }

    if (deviceType === 'mobile' && mobileToPX) {
        const valueAsVW = convertToVw(value, true, false);
        return convertToPx(valueAsVW, true);
    }
};
